import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPayScale } from '../../pay-scales.types';

/**
 * Handles display of pay trips card
 */
@Component({
	selector: 'app-pay-scales-trips-card',
	templateUrl: './pay-scales-trips-card.component.html'
})
export class PayScalesTripsCardComponent implements OnInit {
	@Input() public payScale: IPayScale;

	@Output() public estimatedNumberOfTrips: EventEmitter<number> = new EventEmitter<number>();

	public numberOfTrips: number;

	public ngOnInit(): void {
		if (!this.payScale) {
			return;
		}
	}

	public calculate(): void {
		this.estimatedNumberOfTrips.emit(this.numberOfTrips);
	}
}
